import React, { useState, useEffect, useCallback } from 'react';
import { Button, Table, Spinner, Alert } from 'react-bootstrap';
import { getRegoleSpedizione, deleteRegolaSpedizione } from '../services/api';
import RegolaSpedizioneModal from './RegolaSpedizioneModal'; // Verrà creato in seguito

const RegoleSpedizioneManager = ({ corriereId }) => {
  const [regole, setRegole] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentRegola, setCurrentRegola] = useState(null);

  const fetchRegole = useCallback(async () => {
    setLoading(true);
    try {
      // Nota: l'API getRegoleSpedizione dovrà essere modificata per accettare un corriereId
      const res = await getRegoleSpedizione(corriereId); 
      setRegole(res.data);
    } catch (err) {
      setError('Errore nel caricamento delle regole di spedizione.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [corriereId]); // fetchRegole dipende da corriereId, quindi lo includiamo

  useEffect(() => {
    if (corriereId) {
      fetchRegole();
    }
  }, [corriereId, fetchRegole]); // Ora fetchRegole è una dipendenza stabile

  const handleAdd = () => {
    setCurrentRegola(null);
    setShowModal(true);
  };

  const handleEdit = (regola) => {
    setCurrentRegola(regola);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sei sicuro di voler eliminare questa regola?')) {
      try {
        await deleteRegolaSpedizione(id);
        fetchRegole(); // Ricarica la lista dopo l'eliminazione
      } catch (err) {
        alert('Errore durante l\'eliminazione della regola.');
        console.error(err);
      }
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    fetchRegole(); // Ricarica le regole dopo aver chiuso il modale
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={handleAdd}>
          Aggiungi Regola
        </Button>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Nome Regola</th>
            <th>Canale</th>
            <th>Logica</th>
            <th>Costo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {regole.map((regola) => (
            <tr key={regola.id}>
              <td>{regola.nome_regola}</td>
              <td>{regola.canale}</td>
              <td>{regola.codice_logica}</td>
              <td>€ {regola.costo.toFixed(2)}</td>
              <td>
                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(regola)} className="me-2">
                  Modifica
                </Button>
                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(regola.id)}>
                  Elimina
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <RegolaSpedizioneModal
        show={showModal}
        handleClose={handleModalClose}
        regola={currentRegola}
        corriereId={corriereId}
      />
    </>
  );
};

export default RegoleSpedizioneManager;
